import React from 'react';
import { connect } from 'react-redux';
import { Menu } from 'semantic-ui-react';
import classNames from 'classnames';
import SidenavItem from './SidenavItem';
import SidenavLayout from './SidenavLayout';
import './index.css';

const Sidenav = ({ sidenavState, ...props }) => {
  return (
    <Menu
      vertical
      compact
      inverted
      className={classNames('sidenav-menu', sidenavState)}
      {...props}
    />
  );
};

Sidenav.Item = SidenavItem;
Sidenav.Layout = SidenavLayout;

export { SidenavItem };
export { SidenavLayout };

const mapStateToProps = state => ({
  sidenavState: state.viewManagement.sidenavState
});

export default connect(mapStateToProps)(Sidenav);
